export const headers = [
  { text: 'Học sinh', value: 'student', width: '200px' },
  { text: 'Lớp', value: 'class', width: '100px' },
  { text: 'Xe tuyến', value: 'bus.name', width: '70px' },
  { text: 'Giáo viên phụ trách', value: 'driver', width: '170px' },
  { text: 'SDT giáo viên phụ trách', value: 'driverPhone', width: '200px' },
  { text: 'Giáo viên chủ nhiệm', value: 'headTeacher', width: '170px' },
  { text: 'SDT giáo viên chủ nhiệm', value: 'headTeacherPhone', width: '200px' },
  { text: 'Trạng thái', value: 'status', align: 'center', width: '330px' },
  { text: 'Trạng thái đăng kí xe', value: 'register', align: 'center', width: '120px' },
  { text: 'Thao tác', value: 'action', width: '80px' }
]
